<!-- 自定义列设置弹窗 -->
<template>
    <div v-loading="loading">
        <div class="set-content">
            <draggable v-model="columnData">
                <div v-for="item in columnData" :key="item.ColumnCode" class="set-item">
                    <el-checkbox :disabled="!item.IsCanSet" :checked="item.IsShow" v-model="item.IsShow" border class="item-canset"></el-checkbox>
                    <el-input v-model="item.ColumnName" :disabled="item.ColumnName == '操作'" class="item-cname"></el-input>
                    <el-input v-model="item.Width" :disabled="item.ColumnName == '操作'" class="item-width">
                        <template popper-class="item-width-title" slot="prepend">宽度</template>
                        <template popper-class="item-width-title" slot="append">PX</template>
                    </el-input>
                </div>
            </draggable>
        </div>
        <div slot="footer" class="dialog-footer" style="text-align: right; margin-top: 20px; padding-bottom: 10px">
            <el-button class="search-btn" size="small" type="danger" @click="clearCache">清除缓存</el-button>
            <el-button class="search-btn" size="small" type="warning" @click="restoreDefault">恢复默认</el-button>
            <el-button class="search-btn" size="small" @click="closeDialog(false)">取消</el-button>
            <el-button class="search-btn btn-primary" size="small" @click="submit">保存设置</el-button>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    name: '',
    props: ['tableCode'],
    components: {
        draggable
    },
    data() {
        return {
            index: 0,
            columnData: [],
            loading: false
        };
    },
    created() {
        // 阻止火狐的默认拖拽事件
        document.body.ondrop = event => {
            event.preventDefault();
            event.stopPropagation();
        };
    },
    mounted() {
        let dom = document.getElementsByClassName('table-sets-dialog');
        if(dom&&dom.length >0){
            if(dom.length ==1){
                this.getSetsData();
            }else{
                ///处理chjtablecolumn组件重复打开弹框的BUG
                if(dom[0])
                    dom[0].remove();
            }
        }else{
            //非table中使用
            this.getSetsData(); 
        }
    },
    methods: {
        getSetsData() {
            this.loading = true;
            this.$util
                .getTableSetsData(this.tableCode)
                .then(data => {
                    this.columnData = data;
                    this.loading = false;
                })
                .catch(res => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        submit() {
            this.loading = true;
            // 重新排序
            let dataSort = this.columnData.map((m, i) => {
                return Object.assign(m, { SortNum: i + 1 });
            });
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/SubmitStaffTableSets',
                    data: { TableCode: this.tableCode, ColumnData: this.columnData },
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.closeDialog(true);
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        restoreDefault() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: `/api/EntpInfoManagement/RestoreDefaultTableSets?tableCode=${this.tableCode}`,
                    hideLoading: true
                })
                .then(res => {
                    this.$util.successMsg(res.errmsg);
                    this.closeDialog(true);
                })
                .catch(() => {})
                .finally(() => {
                    this.loading = false;
                });
        },
        closeDialog(isEdit) {
            if (isEdit) {
                this.$util.clearLocalStorage('ts_' + this.tableCode);
                this.$util.clearLocalStorage('ts_temp_' + this.tableCode);
            }
            this.$emit('closeDialog', isEdit);
        },
        clearCache() {
            this.$util.clearLocalStorage('ts_temp_' + this.tableCode);
            this.$util.clearLocalStorage('ts_' + this.tableCode);
            this.getSetsData();
        }
    }
};
</script>
<style lang="less" scoped>
.set-content {
    display: flex;
    flex-direction: column;

    .set-item {
        display: flex;
        flex-direction: row;

        .item-canset {
            width: 7%;
            border-radius: 5px 0 0 5px;
        }

        .item-cname {
            width: 63%;
        }

        .item-width {
            width: 40%;
        }
    }
    .el-input-group__prepend {
        padding: 0 10px;
        border-radius: 0;
    }
    .el-input-group__append {
        padding: 0 10px;
    }
    .el-input__inner {
        border-radius: 0;
    }
}
</style>
